export default {
  type: 'x12_rejection_reason',
  config: null
};
//# sourceMappingURL=x12_rejection_reason.js.map